import { generateRandom2Digits } from '@helpers';

import PbDashboardColumn from '../PbDashboardColumn.vue';

import PbDashboardQueuesProcessingJobsReplacer from './_processingJobsReplacer.vue';

import { calculateTotalTime, generateTimeStrFromHoursMinutesObj } from '../../_helpers/time';

// types matching from backend
export const BASKETS_ACTIONS = Object.freeze({
  BEGIN: { state: 'begin', action: 'beginBasket', name: 'Begin' },
  MARK_BASKET_LOADED: { state: 'loading', action: 'markBasketLoaded', name: 'Mark loaded' },
  MARK_BASKET_UNLOADED: { state: 'unloading', action: 'markBasketUnloaded', name: 'Mark unloaded' },
  PROCESS_BASKET: { state: 'queued', action: 'processBasket', name: 'Process' },
});

export default {
  name: 'PbDashboardQueues',

  props: {
    printMachines: {
      type: Array,
      required: true,
    },

    queues: {
      type: Object,
      required: true,
      validator: ({ inProgress, notStarted }) => Boolean(inProgress && notStarted),
    },

    showNoBasketsText: {
      type: Boolean,
      default: true,
    },

    showNoQueuesText: {
      type: Boolean,
      default: true,
    },
  },

  components: {
    PbDashboardColumn,
    PbDashboardQueuesProcessingJobsReplacer,
  },

  computed: {
    queueEstimatedTime() {
      const { inProgress, notStarted } = this.queues;

      return this.printMachines.reduce((acc, machine) => {
        const timeConfig = calculateTotalTime({
          items: [...(inProgress[machine] || []), ...(notStarted[machine] || [])],
        });

        acc[machine] = generateTimeStrFromHoursMinutesObj(timeConfig);

        return acc;
      }, {});
    },

    jobsCountByMachineName() {
      const { inProgress, notStarted } = this.queues;

      return this.printMachines.reduce((acc, machine) => {
        acc[machine] = [...(inProgress[machine] || []), ...(notStarted[machine] || [])]
          .reduce((accCount, { count }) => accCount + count, 0);

        return acc;
      }, {});
    },
  },

  methods: {
    getActionTextByMachine(machine) {
      const [basket] = this.queues.inProgress[machine] || [];

      return basket
        ? Object.values(BASKETS_ACTIONS).find(({ state }) => basket.state === state).name
        : BASKETS_ACTIONS.BEGIN.name;
    },

    getNextMachinesExcludeCurrent(currentMachine) {
      return this.printMachines.filter(machine => machine !== currentMachine);
    },

    getItemsLengthByMachine(items, machine) {
      return items?.[machine]?.length || 0;
    },

    processBasketActionByMachine(machine) {
      const [basket = {}] = this.queues.inProgress[machine];
      const state = basket.state || 'begin';
      const action = Object.values(BASKETS_ACTIONS).find(a => a.state === state);

      const confirmDigital = generateRandom2Digits();

      this.$VBlackerTheme.alert.warning({
        placeholder: `Please confirm to cancel basket by typing in '${confirmDigital}'`,
        text: `${action.name} basket?`,
        withInput: state === 'queued',
        label: `Typing in '${confirmDigital}'`,
        validator: v => Number(v) === confirmDigital,
        outlined: true,
      }, () => {
        if (state === BASKETS_ACTIONS.PROCESS_BASKET.state) {
          this.$refs.processingJobsReplacerDialog.$_openDialog(basket.id, machine);
        } else {
          this.$emit(
            `process:basket-${action.state}`,
            { machine, basketId: basket.id },
          );
        }
      });
    },

    processBasketWithJobs(params) {
      this.$emit(`process:basket-${BASKETS_ACTIONS.PROCESS_BASKET.state}`, params);
    },
  },
};
